<template>
  <div class="ca-toolbar">
    <div class="ca-toolbar__views" role="tablist" :aria-label="$t('cleaner_activity')">
      <button
        v-for="option in viewOptions"
        :key="option"
        type="button"
        role="tab"
        class="ca-toolbar__view"
        :class="{ 'is-active': view === option }"
        :aria-selected="view === option ? 'true' : 'false'"
        @click="setView(option)"
      >{{ $t(`ca_view_${option}`) }}</button>
    </div>

    <div class="ca-toolbar__period">
      <slot></slot>
    </div>

    <div v-if="$slots.actions" class="ca-toolbar__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
const VIEW_OPTIONS = ['shift', 'history']

/**
 * Single control bar shared by the Shift and History views. The selected view lives in the URL
 * (`?view=history`) so a refresh or shared link opens the same view.
 */
export default {
  data() {
    return { viewOptions: VIEW_OPTIONS }
  },
  computed: {
    view() {
      return this.$route.query.view === 'history' ? 'history' : 'shift'
    },
  },
  methods: {
    setView(view) {
      if (view === this.view) return
      const query = { ...this.$route.query }
      if (view === 'history') query.view = 'history'
      else delete query.view
      this.$router.replace({ query }).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.ca-toolbar {
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 12px 16px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #eef0f3;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

  &__views {
    display: inline-flex;
    gap: 2px;
    flex-shrink: 0;
    padding: 3px;
    background: #eef0f3;
    border-radius: 8px;
  }

  &__view {
    min-height: 30px;
    padding: 0 16px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #5a6573;
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;

    &:hover:not(.is-active) {
      color: #2c3e50;
    }

    &.is-active {
      background: #fff;
      color: #2c3e50;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
    }
  }

  &__period {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    flex: 1 1 auto;
    flex-wrap: wrap;
    min-width: 0;
    padding-inline-start: 16px;
    border-inline-start: 1px solid #eef0f3;
  }

  &__actions {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    margin-inline-start: auto;
  }
}

@media (max-width: 767px) {
  .ca-toolbar {
    align-items: stretch;
    padding: 10px;

    &__views {
      width: 100%;
    }

    &__view {
      flex: 1;
    }

    &__period {
      width: 100%;
      padding-inline-start: 0;
      border-inline-start: none;
    }

    &__actions {
      width: 100%;
      margin-inline-start: 0;
    }
  }
}
</style>
